import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface ThemeState {
    value: string;
}

const initialState: ThemeState = {
    value: localStorage.getItem("theme") ? localStorage.getItem("theme") : "light", // Default theme is light 'dark', 'dim' or 'light'
};

const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        setTheme: (state, action: PayloadAction<string>) => {
            localStorage.setItem("theme", action.payload);
            state.value = localStorage.getItem("theme");
        },
    },
});

export const {setTheme} = themeSlice.actions;
export default themeSlice.reducer;